export default "/images/why_work_with_us/regulatory_compliance.png";